import IconWrapper, { type IconWrapperProps } from '@/components/bases/IconWrapper';

export const HighLightHorizontal = ({ width, height, size = 24, color = '#0ACBE6' }: IconWrapperProps) => {
  const w = width || size;
  const h = height || size;

  return (
    <IconWrapper width={w} height={h} color={color}>
      <svg width={w} height={h} viewBox='0 0 65 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M22.4138 10L10.0862 10L-4.37114e-07 2.84124e-06L12.3276 3.25606e-06L22.4138 10Z' fill='currentColor' />
        <path d='M42.5862 10L30.2586 10L20.1724 1.95948e-06L32.5 2.37429e-06L42.5862 10Z' fill='currentColor' />
        <path d='M65 10L52.6724 10L42.5862 9.79738e-07L54.9138 1.39456e-06L65 10Z' fill='currentColor' />
      </svg>
    </IconWrapper>
  );
};
